
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref } from '@nuxtjs/composition-api';
import usePlaymix from '@/composable/usePlaymix'

export default {
  components: { FontAwesomeIcon },
  props: {
    identifier: {
      type: String,
      default: ''
    },
    invertedVersion: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { selected, data, selection } = usePlaymix(props.identifier)

    const showModal = ref(false)
    const modalData = ref(null)

    const openModal = (service) => {
      showModal.value = true
      modalData.value = service
    }
    const closeModal = () => {
      showModal.value = false
      modalData.value = null
    }

    const onChange = e => {
      // remove selection
      if (selection.value.includes(e)) {
        const arr = [...selection.value]
        arr[selection.value.indexOf(e)] = null
        selection.value = arr
        return
      }
      // add selection
      let isSet = false
      selection.value.forEach((item, i) => {
        if (item === null && !isSet) {
          const arr = [...selection.value]
          arr[i] = e
          selection.value = arr
          isSet = true
        }
      })
    }

    return {
      openModal,
      closeModal,
      onChange,
      showModal,
      modalData,
      selection,
      selected,
      data
    };
  }
}
